import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Check for valid phone number
 * @param {string} phoneNumber string containing phone number without calling code
 * @param {string} countryCode calling code of country
 * @returns {boolean} is valid phone number?
 */
const isPhone = (phoneNumber, countryCode) => {
  if (typeof phoneNumber === 'string' && typeof countryCode === 'string') {
    const parsedPhoneNumber = parsePhoneNumberFromString(`+${countryCode}${phoneNumber}`);
    if (parsedPhoneNumber) {
      return parsedPhoneNumber.isPossible();
    }
  }
  return false;
};
export default isPhone;
